import React, { useContext } from 'react';
import { Label, Spinner, SpinnerSize } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import '../css/controll/noDataFound.scss'
import { LoadingAppContext } from '../context/loadingApp.context';
export const LoadingApp = () => {

    const { LoadingStatus, label } = useContext(LoadingAppContext);
    const { t } = useTranslation();
    return (
        <>
            {(LoadingStatus.Ishow) && (
                <div style={LoadingStatus.Style ? LoadingStatus.Style : undefined} className="loading-full">
                    <Spinner label={!!label ? label : "Wait..."} size={SpinnerSize.large} className={"center"} ariaLive="assertive" labelPosition="bottom" />
                </div>
            )}
        </>
    );
};

